module.exports = __webpack_public_path__ + "static/img/MAZDA.544c91f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos_vehicules/MAZDA.png
// module id = I0Qo
// module chunks = 1